<div class="catalog-price-rules-container" *ngIf="loyaltyEnabled">
  <!-- Pricing Rules -->
  <div class="price-rules">
    <span class="title">{{ "Catalogs.new_catalog.price_book.pricing_rules" | translate }}</span>
    <div class="info">
      <ui-svg-icon svgIcon="info-cc"></ui-svg-icon>
      {{ "Catalogs.new_catalog.price_book.pricing_rules_desc" | translate }}
    </div>
    <div class="price-rules-list">
      <div class="price-rule-item header">
        <div>{{ "Catalogs.new_catalog.price_book.name" | translate }}</div>
        <div>{{ "Catalogs.new_catalog.price_book.audience" | translate }}</div>
        <div>{{ "Catalogs.new_catalog.price_book.calculation_type" | translate }}</div>
        <div>{{ "Catalogs.new_catalog.price_book.status" | translate }}</div>
      </div>
      <div class="price-rules-list-content">
        <ng-container *ngIf="pricingRules.length > 0; else noPricingRules">
          <div class="price-rule-item data" *ngFor="let pricingRule of pricingRules">
            <div>{{ pricingRule.name }}</div>
            <div class="stacked-col">
              <div>{{ pricingRule.audience }}</div>
              <!-- <div class="secondary-text">1 Company</div> -->
            </div>
            <div class="stacked-col">
              <div [title]="getPricebookCalculationTypeDisplayText(pricingRule.calculation_type)">{{ getPricebookCalculationTypeDisplayText(pricingRule.calculation_type) || "--" }}</div>
              <div class="secondary-text" *ngIf="pricingRule.calculation_type === 'extra_discount_on_products' || pricingRule.calculation_type === 'extra_discount_on_full_order'">{{ (pricingRule.thresholds.length > 0 ? 'pricebook.up_to' : '') | translate }} {{ (pricingRule.extra_discount || 0 | number : "1.0-2") + "%" }} {{ 'pricebook.form.extra_discount' | translate }}</div>
            </div>
            <div>
              <div [class]="pricingRule.active ? 'active--tag' : 'danger--tag'">{{ (pricingRule.active ? "pricebook.active" : "pricebook.inactive") | translate }}</div>
            </div>
          </div>
        </ng-container>
        <ng-template #noPricingRules>
          <div class="no-data-container" style="text-align: center; padding: 10px">{{ "Catalogs.new_catalog.price_book.no_price_rules" | translate }}</div>
        </ng-template>
      </div>
    </div>
  </div>
  <!-- Promotions -->
  <div class="price-rules">
    <span class="title">{{ "Catalogs.new_catalog.price_book.promotions" | translate }}</span>
    <div class="info">
      <ui-svg-icon svgIcon="info-cc"></ui-svg-icon>
      {{ "Catalogs.new_catalog.price_book.promotions_desc" | translate }}
    </div>
    <div class="filters">
      <ui-form-field [formControl]="searchInput" [suffixIcon]="'search_icon'" [placeholder]="'common.search' | translate"></ui-form-field>

      <!-- <ui-button type="transparent" icon="plus-cc" iconSize="large" [label]="'add promotion' | translate" (click)="addPromotion()"></ui-button> -->
    </div>
    <div class="price-rules-list">
      <div class="price-rule-item header">
        <div>{{ "Catalogs.new_catalog.price_book.name" | translate }}</div>
        <div>{{ "Catalogs.new_catalog.price_book.audience" | translate }}</div>
        <div>{{ "Catalogs.new_catalog.price_book.calculation_type" | translate }}</div>
        <div>{{ "Catalogs.new_catalog.price_book.status" | translate }}</div>
      </div>
      <div class="price-rules-list-content">
        <ng-container *ngIf="promotions.length > 0; else noPromotions">
          <div class="price-rule-item data" *ngFor="let promotion of filteredPromotions">
            <div>{{ promotion.name }}</div>
            <div class="stacked-col">
              <div>{{ promotion.audience }}</div>
            </div>
            <div class="stacked-col">
              <div [title]="getPricebookCalculationTypeDisplayText(promotion.calculation_type)">{{ getPricebookCalculationTypeDisplayText(promotion.calculation_type) || "--" }}</div>
              <div class="secondary-text"  *ngIf="promotion.calculation_type === 'extra_discount_on_products' || promotion.calculation_type === 'extra_discount_on_full_order'">{{ (promotion.thresholds.length > 0 ? 'pricebook.up_to' : '') | translate }} {{ (promotion.extra_discount || 0 | number : "1.0-2") + "%" }} {{ 'pricebook.form.extra_discount' | translate }}</div>
            </div>
            <div>
              <label class="switch" (pointerdown)="togglePromotionConfirmation($event, promotion)">
                <input type="checkbox" [checked]="promotion.active" (click)="$event.stopImmediatePropagation()" />
                <span class="slider round"></span>
              </label>
            </div>
          </div>
        </ng-container>
        <ng-template #noPromotions>
          <div class="no-data-container" style="text-align: center; padding: 10px">{{ "Catalogs.new_catalog.price_book.no_promotions" | translate }}</div>
        </ng-template>
      </div>
    </div>
  </div>
</div>
